export enum IndexDBKeyNames{
    DIRECTORY_SEARCH_RESPONSE = "searchResponse"
}